/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlUserResponse } from './ControlUserResponse';
import {
    ControlUserResponseFromJSON,
    ControlUserResponseFromJSONTyped,
    ControlUserResponseToJSON,
} from './ControlUserResponse';

/**
 * 
 * @export
 * @interface ControlAssociateUsersResponse
 */
export interface ControlAssociateUsersResponse {
    /**
     * 
     * @type {Array<ControlUserResponse>}
     * @memberof ControlAssociateUsersResponse
     */
    results: Array<ControlUserResponse>;
}

/**
 * Check if a given object implements the ControlAssociateUsersResponse interface.
 */
export function instanceOfControlAssociateUsersResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlAssociateUsersResponseFromJSON(json: any): ControlAssociateUsersResponse {
    return ControlAssociateUsersResponseFromJSONTyped(json, false);
}

export function ControlAssociateUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssociateUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ControlUserResponseFromJSON)),
    };
}

export function ControlAssociateUsersResponseToJSON(value?: ControlAssociateUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(ControlUserResponseToJSON)),
    };
}

